import type { TFunction } from 'i18next';

/**
 * A new file has coordinates of its own, so what is drawn on the old one goes back
 * to being drawn. Asked when there is something to lose, and only then.
 */
export function confirmLinesLost(place: { model_3d_lines_count?: number | null }, t: TFunction) {
  const count = place.model_3d_lines_count ?? 0;
  return count === 0 || window.confirm(t('cragModel.current.linesLost', { count }));
}
